<template>
  <div>
    <div class="bg-white">
      <div class="container py-2">
        <br>
        <div class="row">
          <div class="col-lg-1">
            <router-link to="/owner" class="btn btn-sm btn-xs btn-outline-secondary d-none d-md-inline-block"><i class="fas fa-chevron-left"></i> Back</router-link>
          </div>
          <div class="col-lg-8 offset-lg-1">
            <br class="d-none d-lg-block">
            <h1 class="h2 text-center mt-2">How much can you earn?</h1>
            <p class="lead grey text-center px-md-5 mb-4">Calculate how much revenue your trailers can generate when listed with PNO.</p>
            <div class="card">
              <div class="card-header small">
                <small class="grey text-uppercase">Revenue Calculator </small> <i class="fal fa-lg fa-calculator grey float-right mt-1"></i>
              </div>
              <div class="card-body">
                <form class="calculator">
                  <div class="row text-center mb-4">
                    <div class="col">
                      <h3 class="h1 mb-0 mt-2"><strong><small>€</small>600</strong></h3>
                      <small>per month</small>
                    </div>
                    <div class="col">
                      <h3 class="h1 mb-0 mt-2"><strong><small>€</small>7,200</strong></h3>
                      <small>per year</small>
                    </div>
                  </div>
                  <hr>
                  <div class="row text-center mb-4">
                    <div class="col">
                      <img :src="require('@/assets/img/trailer_front_left.png')" class="img-fluid mb-1" alt="Curtain Trailer">               
                      <label>Curtain</label>
                      <select class="form-control">
                        <option>0</option>
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                    <div class="col">
                      <img :src="require('@/assets/img/trailer_front_right.png')" class="img-fluid mb-1" alt="Reefer Trailer">               
                      <label>Reefer</label>
                      <select class="form-control">
                        <option>0</option>
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                    <div class="col">
                      <img :src="require('@/assets/img/trailer_back_left.png')" class="img-fluid mb-1" alt="Box Trailer">               
                      <label>Box</label>
                      <select class="form-control">
                        <option>0</option>
                        <option selected>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group mb-1">
                    <label>Average rental days per month</label>
                    <select class="form-control">
                      <option>5</option>
                      <option>10</option>
                      <option selected>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>
    
    <pno-list />
    
  </div>  
  
</template>

<script>
import PnoList from '@/components/PnoList.vue'

export default {
    mounted() {
      this.$store.commit('meta/title', 'Revenue Calculator')
      this.$store.commit('meta/description', 'Calculate how much revenue your trailers can generate when listed with PNO.')
    },
	components: { PnoList }
}
</script>
